import { queryOptions } from '@tanstack/react-query';
import type { PhotoModerationQueueResponse } from '@upme/contracts';
import { api } from '../../app/api-client';

export const photoModerationKey = ['admin', 'photo-moderation'] as const;

export const listPhotoModerationOptions = () =>
  queryOptions({
    queryKey: [...photoModerationKey, 'list'] as const,
    queryFn: () => api.get('admin/photo-moderation').json<PhotoModerationQueueResponse>(),
    staleTime: 5_000,
  });
